import type { App } from "vue"
import BasePagination from "@/components/table/BasePagination/BasePagination.vue"
import BaseTable from "@/components/table/BaseTable/BaseTable.vue"
import { Container, NavBack } from "@/layout/components"
import { getEnv } from "@/utils"
import { loadElementPlus } from "./element-plus"
import { loadElementPlusIcon } from "./element-plus-icon"
import { loadMediaJudgement } from "./mediaJudgementPlugin"
import { loadSimpleKeyboard } from "./simple-keyboard"
import { loadVueQrcode } from "./vue-qrcode"
import { loadZod } from "./zod"

/**
 * 加载公共组件
 * @param app
 */
function loadCommonComponents(app: App) {
  app.component("Container", Container)
  app.component("NavBack", NavBack)
  app.component('BaseTable', BaseTable)
  app.component('BasePagination', BasePagination)
}

/**
 * 将常用的工具方法挂载到 window 上
 */
function mountOnWindow() {
  window.appInfo = {
    apiUrl: 'https://api.example.com',
    version: '1.0.0',
  }
  // window.zdValidate = {
  // }
}

export function loadPlugins(app: App) {
  // 开发环境全量加载，其他环境按需加载
  if (getEnv() === 'development') {
    loadElementPlus(app)
  }

  loadElementPlusIcon(app)
  loadVueQrcode(app)
  loadZod(app)
  loadSimpleKeyboard(app)
  loadMediaJudgement(app)
  loadCommonComponents(app)
  mountOnWindow()
}
